import { apiCall } from "./client";

export const getNotificationInbox = (params = {}) => {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const qs = search.toString();
  return apiCall(`/api/notifications/inbox${qs ? `?${qs}` : ""}`);
};

export const getNotificationUnreadCount = () =>
  apiCall("/api/notifications/unread-count");

export const getNotificationUnseenCount = () =>
  apiCall("/api/notifications/unseen-count");

export const markNotificationsSeen = (ids) =>
  apiCall("/api/notifications/seen", {
    method: "PUT",
    body: JSON.stringify({ ids }),
  });

export const markNotificationRead = (id) =>
  apiCall(`/api/notifications/${id}/read`, { method: "PUT" });

export const markAllNotificationsRead = () =>
  apiCall("/api/notifications/read-all", { method: "PUT" });

export const deleteNotification = (id) =>
  apiCall(`/api/notifications/${id}`, { method: "DELETE" });

export const deleteAllNotifications = () =>
  apiCall("/api/notifications/delete-all", { method: "DELETE" });
